import type { CampaignStatus, PropTypes } from './CampaignTag.types';
import type { BadgeProps } from '@rango-dev/whale';
import type { ReactElement } from 'react';

import { Badge } from '@rango-dev/whale';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useAppSelector } from '../../../hooks/reduxHooks';

import { calculateCampaignStatus } from './CampaignTag.helpers';

const STATUS_BADGE_COLOR: Record<CampaignStatus, BadgeProps['color']> = {
  upcoming: 'purple',
  ongoing: 'blue',
  ended: 'gray',
  unknown: 'gray',
};

export function CampaignTag(props: PropTypes): ReactElement {
  const { t } = useTranslation();
  const { data: dynamicCampaigns } = useAppSelector((state) => state.campaign.campaigns);
  const campaign = dynamicCampaigns?.find((campaign) => campaign.campaignId === props.id);
  let status: CampaignStatus = 'ended';
  if (campaign) {
    status = calculateCampaignStatus(campaign?.start, campaign?.end);
  }

  const badgeColor = STATUS_BADGE_COLOR[status];

  return (
    <Badge color={badgeColor} variant="surface">
      {status === 'upcoming' && t('Upcoming')}
      {status === 'ongoing' && t('Ongoing')}
      {status === 'ended' && t('Ended')}
    </Badge>
  );
}
